/**
 * Activities landing page (TRAV23 activities-front merge).
 *
 * The activities front served this at `/:accountUsername/home`. That path is RSI's own
 * home, so it moves to `/:accountUsername/activities` - the activities section root.
 */

import { ActivityHome } from '@components';

export function ActivityHomePage() {
  return <ActivityHome />;
}
